<template>
    <footer class="text-center text-sm text-gray-500 mt-8">
      <a href="http://beian.miit.gov.cn/">
        蜀ICP备2020033343号-2
      </a>
    </footer>
</template>
  